import { gt } from 'lodash'

export function isPositiveNumber(value: number | string | null | undefined): boolean {
  return gt(value, 0)
}
